// ═══════════════════════════════════════════════════════════════
// upsell.js — Gestion légère des réponses de quota/palier (freemium)
// Chantier #2 abonnements ITRIIA.
// ═══════════════════════════════════════════════════════════════
// Le backend renvoie, sur dépassement, un payload :
//   { code: 'QUOTA_EXCEEDED'|'TIER_REQUIRED', error, quota, upsell:{cta,...} }
// (429 pour les messages, 403 pour les features premium).
//
// handleUpsell(body) : si le payload est un upsell connu, affiche un toast
// avec le CTA et émet un événement global `itriia-upsell` (qu'une future
// page pricing / modale d'upgrade — chantier #5 — pourra écouter). Retourne
// true si le payload a été pris en charge, false sinon.
// ═══════════════════════════════════════════════════════════════

import { toast } from '../components/ui/Toast';

const UPSELL_CODES = new Set([
    'QUOTA_EXCEEDED',          // quota messages/mois (chantier #2)
    'TIER_REQUIRED',           // feature réservée palier payant (#2)
    'LLM_ALLOWANCE_EXCEEDED',  // enveloppe LLM incluse atteinte (#3)
    'BYOK_REQUIRED',           // clé OpenRouter perso requise (#3)
]);

export function isUpsell(body) {
    return !!(body && UPSELL_CODES.has(body.code));
}

export function handleUpsell(body) {
    if (!isUpsell(body)) return false;

    const message = body.error || 'Limite de ton offre atteinte.';
    const cta = body.upsell && body.upsell.cta ? ` — ${body.upsell.cta}` : '';
    toast.warning(`${message}${cta}`, 6000);

    // Hook pour le chantier #5 (modale/page pricing) sans coupler ici.
    try {
        window.dispatchEvent(new CustomEvent('itriia-upsell', { detail: body }));
    } catch (_) { /* SSR / environnements sans window : no-op */ }

    return true;
}

export default handleUpsell;
